<h1 #detailsHeading tabindex="-1" class="visually-hidden">Navigated to Order Details Screen</h1>

<section *ngIf="showContent" class="order-details">
  <section class="py-2 px-3 bg-pale-blue mb-3 rounded">
    <div class="row align-items-center">
      <div class="col-12 col-md-4 mb-3 mb-sm-0 semi-bold-text">
         <label>
          <span class="heading-color">Order Number: </span>{{orderDetails?.id}}  
          @if(orderDetails?.clientActionRequired){
            <i role="img" aria-label="client Action Required" class="pi pi-flag-fill ms-2" style="color: #D13438;"></i>
          }
        </label>
      </div>
      <div class="col-12 col-md-8 mb-3 mb-sm-0 d-flex justify-content-end ">
        <p-button class="need-help-btn-x" (click)="needHelp()" [link]="true"> Need help?</p-button>
        @if(!isUserLinkedToAccount){
          <p-button aria-label="Edit Order Details"  label="Edit Order Details" icon="pi pi-pencil" (click)="editOrder(orderDetails?.id)" [link]="true" />
        }
        <p-button aria-label="Add Provider"  id="add-provider-button" severity="secondary" label="Add Provider" (click)="isAddProviderClicked = true" />
      </div>
    </div>
  </section>
  <section class="p-3 bg-light-blue rounded mb-3">
    <div class="row">
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Claim Number</label>
      <label>{{orderDetails?.claimNumber}}</label>
    </div>
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Date of Incident</label>
      <label>{{orderDetails?.dateOfIncident}}</label>
    </div>
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Client Name</label>
      <label>{{orderDetails?.carrierName}}</label>
    </div>
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Account Name</label>
      <label>{{orderDetails?.accountName}}</label>
    </div>

    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Type of Order</label>
      <label>{{orderDetails?.typeOfOrder}}</label>
    </div>
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Service Level</label>
      <label>{{orderDetails?.serviceLevel}}</label>
    </div>
    <div class="col-sm-12 col-md-6 col-lg mb-2 mb-lg-0">
      <label class="medium-text d-block">Status</label>
      <label>{{orderDetails?.orderStatus || '--'}}</label>
    </div>
  </div>
  </section>
  <section *ngIf="isAddProviderClicked">
    <app-add-provider [orderData]="orderData" [tableData]="recordRequests" [subjects]="orderDetails?.subjects" [selectedCategory]="orderDetails?.typeOfOrder" [orderNumber]="orderDetails?.id || ''" [orderUpdateData]="orderUpdateData" [vocabDocumentTagsData]="vocabDocumentTagsData" (addProvider)="onAddProvider()" (onSaveProvider)="onInitOrderDetails(true)"></app-add-provider>
  </section>
  <p-tabs value="0" class="">
    <p-tablist>
      <p-tab value="0">Records</p-tab>
      <p-tab value="1">General Information</p-tab>
      <!-- <p-button tabIndex="0" class="need-help-btn" styleClass="pe-0" (click)="needHelp()" [link]="true"> Need
        help?</p-button> -->
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <span class="sr-only">Records Tab Panel</span>
        <div class="d-flex flex-row justify-content-between pb-3">
          <p-button class="invisible" aria-label="Download All Files" label="Download All" tabIndex="0" (click)="downloadAll()" [disabled]="!hasDocs()" />
          <div class="d-flex flex-row gap-3">
              <button
                type="button"
                class="p-button p-component p-button-link"
                (click)="tableAction('collapseAll')"
                tabIndex="0">
                <i class="fa-solid fa-minimize ml-2 p-button-icon" aria-hidden="true"></i>
                Collapse All<span class="sr-only"> Rows</span>
              </button>
              <button
                type="button"
                class="p-button p-component p-button-link"
                (click)="tableAction('expandAll')"
                tabIndex="0">
                <i class="fa-solid fa-maximize ml-2 p-button-icon" aria-hidden="true"></i>
                Expand All<span class="sr-only"> Rows</span>
              </button>
          </div>
        </div>
        <div>
          <app-record-index-table [tableData]="recordRequests" [orderDetails]="orderDetails" (tableAction)="tableAction($event)" [isTableLoading]="isOrderLoading" [isDocumentsLoading]="isDocumentsLoading"></app-record-index-table>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <span class="sr-only">General Information Tab Panel</span>
        <app-order-details-general-information [isUserLinkedToAccount]="isUserLinkedToAccount" [orderDetails]="orderDetails" [orderData]="orderData" [documents]="orderDocuments" [requestDocuments]="requestDocuments" [vocabDocumentTagsData]="vocabDocumentTagsData" (tableAction)="tableAction($event)"></app-order-details-general-information>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</section>


<!-- add dialogs here -->
<app-modal [header]="'Need Help'" [(showDialog)]="showHelpModal" [acceptLabel]="'Close'"
  (acceptModalClick)="showHelpModal = false" class="">
  <app-need-help-modal></app-need-help-modal>
</app-modal>

<p-toast position="top-center" />